import { create } from "zustand";
import { Category } from "../data/Category";

type CategoryGridStore = {
    selectedCategories: Category[];
    setSelectedCategories: (categories: Category[]) => void;
    clearSelectedCategories: () => void;
}

export const useCategoryGridStore = create<CategoryGridStore>((set) => ({
    selectedCategories: [],
    setSelectedCategories: (categories: Category[]) => set(() => ({ selectedCategories: categories })),
    clearSelectedCategories: () => set(() => ({ selectedCategories: [] })),
}));